import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { ReportField } from "./reportField";
import { getStringOrDefault } from "../../utils/utils";
import { observer } from "mobx-react";

const useStyles = makeStyles(() => ({
  longTextTypography: {
    fontSize: "14px",
    padding: "16px",
    paddingTop: "10px",
    fontWeight: 400,
  },
}));

interface AdverseExternalFactorsBoxProps {
  adverseFactorsComments: string;
}

export const AdverseExternalFactorsBox = observer(({ adverseFactorsComments }: AdverseExternalFactorsBoxProps) => {
  const classes = useStyles();

  return (<FieldSetBox title="Adverse External Factor and Neighborhood">
    <ReportField label="Comments" removeRightBorder>
      <Typography className={classes.longTextTypography}>
        {getStringOrDefault(adverseFactorsComments)}
      </Typography>
    </ReportField>
  </FieldSetBox>);
});